import { css } from '@emotion/react';

const FONT = `'Neue Haas Grotesk Display Pro', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif`;

export const dashboardHeroCSS = () => css`
    font-family: ${FONT};
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 32px;
    margin-bottom: 24px;
    flex-wrap: wrap;

    .dh-left {
        min-width: 0;
        flex: 1 1 auto;
    }

    .dh-eyebrow {
        font-size: 11px;
        font-weight: 600;
        letter-spacing: 0.10em;
        color: #94A3B8;
        text-transform: uppercase;
        margin-bottom: 10px;
        line-height: 1.2;
    }

    .dh-greeting {
        font-size: 22px;
        font-weight: 500;
        color: #0F172A;
        letter-spacing: -0.01em;
        margin-bottom: 4px;
        line-height: 1.2;
    }

    .dh-number-row {
        display: flex;
        align-items: baseline;
        gap: 16px;
        flex-wrap: wrap;
    }

    .dh-number {
        font-size: 76px;
        font-weight: 500;
        letter-spacing: -0.03em;
        line-height: 0.9;
        background: linear-gradient(90deg, #204B7B 0%, #32B8DF 51.04%, #00BA6E 100%);
        -webkit-background-clip: text;
        background-clip: text;
        -webkit-text-fill-color: transparent;
        color: transparent;
    }

    .dh-number-label {
        font-size: 16px;
        color: #475569;
        font-weight: 400;
    }
    .dh-number-label strong {
        color: #0F172A;
        font-weight: 600;
    }

    .dh-delta {
        font-size: 12px;
        color: #1FB874;
        font-weight: 600;
        display: inline-flex;
        align-items: center;
        gap: 4px;
        background: #F0FBF6;
        padding: 4px 10px;
        border-radius: 999px;
        white-space: nowrap;
        align-self: center;
    }

    .dh-slashes {
        display: flex;
        align-items: baseline;
        gap: 12px;
        margin-top: 12px;
        font-size: 13px;
        color: #475569;
        flex-wrap: wrap;
    }
    .dh-slashes strong {
        color: #0F172A;
        font-weight: 600;
    }
    .dh-slash-sep {
        color: #CBD5E1;
        font-weight: 300;
        font-size: 18px;
    }

    .dh-right {
        display: flex;
        gap: 10px;
        align-items: center;
        flex-shrink: 0;
    }

    .dh-search {
        display: flex;
        align-items: center;
        gap: 10px;
        width: 320px;
        max-width: 100%;
        padding: 0 14px;
        height: 40px;
        border-radius: 999px;
        border: 1.5px solid #34C6F1;
        background: #ffffff;
        transition: box-shadow 0.18s ease;
    }
    .dh-search:focus-within {
        box-shadow: 0 0 0 3px rgba(52, 198, 241, 0.18);
    }
    .dh-search i {
        color: #94A3B8;
        font-size: 14px;
        flex-shrink: 0;
    }
    .dh-search input {
        flex: 1;
        min-width: 0;
        border: none;
        outline: none;
        background: transparent;
        font-size: 13.5px;
        font-family: ${FONT};
        color: #0F172A;
    }
    .dh-search input::placeholder {
        color: #94A3B8;
    }

    @media (max-width: 768px) {
        flex-direction: column;
        align-items: stretch;
        gap: 20px;

        .dh-number { font-size: 56px; }
        .dh-right { width: 100%; }
        .dh-search { flex: 1; width: auto; }
    }
`;
